<main [ngStyle]="{'background': backgroundImg, 'background-size': backgroundSize}">
  <router-outlet></router-outlet>
</main>
